import styled from "@emotion/styled";

// color scheme
export const COLORS = {
    primary: "#aa233c",
    primaryLight: "#f7e9ec",
    primaryDark: "#881c30",
    secondary: "#2f2f2f",
    secondaryLight: "#ebebeb",
    secondaryDark: "#222",
    accent1: "#3F826D",
    accent1Light: "#ecf3f1",
    accent1Dark: "#326857",
    accent2: "#f2d0a4",
    accent2Light: "#fefaf6",
    accent2Dark: "#c2a683",
    text: "#404040",
    textMuted: "#666",
    white: "#fff",
    black: "#000",
    offwhite: "#fbfbfb",
    red: "#cc0000",
    lightOverlay: "rgba(130, 130, 130, 0.2)",
    darkOverlay: "rgba(0, 0, 0, 0.2)",
    // primaryLight: "#7693af",
    borderblue: "#acc1d1",
    // primaryorange: "#FF5703",
    // accent1Dark: "#FEC0A9",
    yellow: "#ffd75c",
    darkyellow: "#b78213",
    successaccent: "#D0FCD2",
    borderlight: "rgba(45, 72, 117, 0.24)",
    accordionshadow: "rgba(130, 130, 130, 0.16)",
    fadedprimary: "rgba(45, 72, 117, 0.73)",
    textinputbackground: "#FCFEFE",
    green: "#12B36C",
    hoverorange: "#b83e08",
    hovergreen: "#12B36C",
    accordionbackground: "#FAFDFD",
    dropdowncolor: "#ECF1F4",
    success: "#D0FCD2",
    error: "#fff5f8",
    graphOrange: "#FF5703",
    // primary: "rgba(130, 130, 130, 0.2)",
    greydark10: "#ACC1D1",
    greyLight: "#f2f6f8",
    // greyRectangle69: "#FBFBFB",
    greydark30: "#4B688D",
    accentWarningLight: "#FFF8D3",
    accentWarningDark: "#93640C",
    fadedOrange: "#fd816e",
    accentSuccessDark: "#0C9667",
    breadCrumbcolor: "#C4C4C4",
    disabledgreen: "#DBDEE1",
    indicatorInactive: "#cdd3de",
    blue: "#2263D8",
    // turquoiseGreen: "#008488",
    tiber: "#0B3142",
    aliceBlue: "#ECF1F4",
    dollarbackground: "##F2F6F8",
    newPink: "#E0185B",
    lightNewPink: "#FCE9EE",
    deleteRed: "#fc483f",
    greyLavander: "#ebebf2",
    lightBlack: "#0A0A0A",
    red2: "#E0185B",
    activelinkbg2: "#808080",
    disabledTabs: "rgba(45, 72, 117, 0.24)"
};

// dimensions
export const fontSize = px => `${px / 8}rem`;
export const respSize = px => `${px / 8}rem`;


// input field on the header
export const InputWapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${COLORS.white};
  border-radius: 4px;
  
  width: 100%;
`;


export const Input = styled.input`
  display: inline-block;
  min-width: 100%;
  background-color: ${COLORS.white};
  color: ${COLORS.text};
  font-size: .875em;
  padding: ${fontSize(7)} ${fontSize(8)};
  flex: 1;
  border-radius: 4px;
  border: ${({ onChangeFocus }) =>
          onChangeFocus === true ? "1px solid rgba(64, 64, 64)" : "1px solid #ACC1D1"};

  &::placeholder {
    color: #ACC1D1;
    opacity: 1;
  }
  &:focus {
    border: 1px solid rgba(64, 64, 64);
    outline: none;
  }
`;

export const TextArea = styled.input`
  display: inline-block;
  // min-width: ${respSize(300)};
  min-width: 100%;
  background-color: ${COLORS.white};
  color: ${COLORS.text};
  //font-size: ${fontSize(14)};
  font-size: .875em;
  padding: ${fontSize(8)} ${fontSize(8)};
  //line-height: ${respSize(24)};
  flex: 1;
  //border: none;
  border: ${({ onChangeFocus }) =>
          onChangeFocus === true ? "1px solid rgba(64, 64, 64)" : "1px solid #EBEBF2"};

  &::placeholder {
    color: #d5d5d5;
    opacity: 1;
  }
  &:focus {
    border: 1px solid rgba(64, 64, 64);
    outline: none;
  }
`;

export const Select = styled.select`
  display: inline-block;
  //min-width: ${respSize(300)};
  min-width: 100%;
  background-color: ${COLORS.white};
  color: ${COLORS.text};
  //font-size: ${fontSize(14)};
  font-size: .875em;
  padding: ${fontSize(8)} ${fontSize(8)};
  //line-height: ${respSize(24)};
  flex: 1;
  //border: none;
  border: ${({ onChangeFocus }) =>
          onChangeFocus === true ? "1px solid rgba(64, 64, 64)" : "1px solid #ACC1D1"};

  &::placeholder {
    color: #d5d5d5;
    opacity: 1;
  }
  &:focus {
    border: 1px solid rgba(64, 64, 64);
    outline: none;
  }
`
